const getters = {
	// data
	getCustomer: (state) => state.customer,
	getDetailCustomer: (state) => state.detailCustomer,
	getDetailCustomer2: (state) => state.detailCustomer2,
	getAlamat: (state) => state.alamat,
	getTopFive: (state) => state.topFive,
	getRiwayat: (state) => state.riwayat,

	// filter
	getPagination: (state) => state.pagination,
	getPaginationAlamat: (state) => state.paginationAlamat,
	getSearch: (state) => state.search,
	getSearchAlamat: (state) => state.searchAlamat,
	getIsSearchCustomer: (state) => state.isSerachCustomer,
	getIsSearchAlamat: (state) => state.isSearchAlamat,

	// temporary data
	getDataCreateCustomer: (state) => state.dataCreateCustomer,
	getAlamatTemp: (state) => state.alamatTemp,

	getScrollPosition: (state) => state.scrollPosition,
}

export default getters